import { render, staticRenderFns } from "./DoctorCards.vue?vue&type=template&id=6a3648a2&"
import script from "./DoctorCards.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCards.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3648a2')) {
      api.createRecord('6a3648a2', component.options)
    } else {
      api.reload('6a3648a2', component.options)
    }
    module.hot.accept("./DoctorCards.vue?vue&type=template&id=6a3648a2&", function () {
      api.rerender('6a3648a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/shame-mark/ShameMarkContent/components/DoctorCards.vue"
export default component.exports